import { useQuery } from '@tanstack/react-query'

import $api from '../../API/index.js'

import { ErHealthCheck } from './components/er'
import { NomiStatusDashboard } from './components/nomi-status-files'
import { Nomi835Dashboard } from './components/nomi835'
import { PinnacleDashboard } from './components/pinnacle'
import { PullWorkflowDashboard } from './components/pull-workflow'
import { ShadowWorkflowDashboard } from './components/shadow-workflow'

export function SFTPHealthcheck(): JSX.Element {
  interface ErroredConnection {
    timestamp: string
    errorDescription: string
    error: string
  }
  interface Day {
    date: string
    isOk: boolean
    isDataPresent: boolean
    timestamps: string[]
    errors: ErroredConnection[]
  }

  interface HealthcheckData {
    key: string
    host: string
    username: string
    name: string
    days: Day[]
  }

  const summaryQuery = useQuery({
    queryKey: ['healthcheck'],

    async queryFn({ signal }) {
      const response = await $api.get<HealthcheckData[]>('/healthcheck/sftp/status', {
        method: 'GET',
        signal
      })

      return response.data
    }
  })

  const renderHealthcheckData = () => {
    if (summaryQuery.isLoading) {
      return <p>Loading...</p>
    }

    if (summaryQuery.isError) {
      return <p>Error loading data</p>
    }

    const sftps = summaryQuery.data

    const sftpsSorted = sftps.sort((a, b) => a.key.localeCompare(b.key))

    return (
      <div>
        {sftpsSorted.map((sftp: HealthcheckData) => {
          return (
            <div
              key={sftp.key}
              style={{ marginTop: '50px', border: '1px solid black', padding: '10px' }}
            >
              <h3 style={{ textAlign: 'center', fontWeight: 'bold' }}>{sftp.name}</h3>
              <h3>
                <span style={{ fontWeight: 'bold' }}>Host: </span>
                {sftp.host}
              </h3>
              <h3>
                <span style={{ fontWeight: 'bold' }}>Username: </span>
                {sftp.username}
              </h3>
              <div style={{ display: 'flex', flexDirection: 'row', marginTop: '10px' }}>
                {sftp.days.map((day, index) => {
                  let backgroundColor = 'gray'
                  if (day.isDataPresent) {
                    backgroundColor = day.isOk ? 'green' : 'red'
                  }

                  const date = `Date: ${new Date(day.date).toLocaleDateString()}\n\n`

                  const isOk = `Is OK: ${day.isOk}\n\n`

                  const isDataPresent = `Is Data Present: ${day.isDataPresent}\n\n`

                  // const missingTimestamps = isArray(day.timestamps) && day.timestamps.length > 0
                  // ? `Missing connections:\n${day.timestamps.map(ts => {
                  //   return new Date(Number.parseInt(ts, 10)).toLocaleString()
                  //   }).join('\n')}\n\n` : ''

                  const errors =
                    Array.isArray(day.errors) && day.errors.length > 0
                      ? `Errors:\n${day.errors
                          .map(error => {
                            return `${new Date(Number.parseInt(error.timestamp, 10) * 1000).toLocaleString()} ${error.errorDescription} ${error.error}`
                          })
                          .join('\n\n')}`
                      : ''

                  return (
                    <div
                      key={index}
                      style={{
                        width: '1%',
                        height: '20px',
                        backgroundColor,
                        margin: '0 0.2%'
                      }}
                      title={date + isOk + isDataPresent + errors}
                    />
                  )
                })}
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <div>
      <ErHealthCheck />
      <PullWorkflowDashboard />
      <ShadowWorkflowDashboard />
      <Nomi835Dashboard />
      <NomiStatusDashboard />
      <PinnacleDashboard />
      {renderHealthcheckData()}
    </div>
  )
}
